<app-header [productLength]="productLength"></app-header>
<div style="padding-bottom: 90px;"></div>
<div class="container">
    <!-- <br>
    <div class="row">
        <span class="float-right alert alert-success" (click)="falseAlert()" *ngIf="successAlert">
            {{data}}
        </span>
    </div>
    <div class="row">
        <div class="col-6 col-md-4" *ngFor = "let product of products">
            <img [src]="product.imgPath" width="150" height="120">
            <h4>{{product.name}}</h4>
            <button class="btn btn-primary" (click)="onAddToCard(product)">Add to Card</button>
            <br> <br>
        </div>
    </div> -->
    <app-loader *ngIf="loader"></app-loader>

    <!-- Start -->

    <!--Section: Products v.3-->
    <section class="text-center mb-4">

        <!--Grid row-->
        <div class="row wow fadeIn">

            <!--Grid column-->
            <div class="col-lg-3 col-md-6 mb-4" *ngFor="let product of products">

                <!--Card-->
                <div class="card">

                    <!--Card image-->
                    <div class="view overlay">
                        <img [src]="product.imgPath" class="card-img-top" alt="">
                        <a>
                            <div class="mask rgba-white-slight"></div>
                        </a>
                    </div>
                    <!--Card image-->

                    <!--Card content-->
                    <div class="card-body text-center">
                        <!--Category & Title-->
                        <a href="" class="grey-text">
                            <h5>Shirt</h5>
                        </a>
                        <h5>
                            <strong>
                    <a href="" class="dark-grey-text">{{product.name}}
                      <span class="badge badge-pill danger-color">NEW</span>
                    </a>
                  </strong>
                        </h5>

                        <h4 class="font-weight-bold blue-text">
                            <strong>₹{{product.amount}}</strong>
                        </h4>
                        <button class="btn btn-primary" (click)="onAddToCart(product)">Add to Cart</button>
                    </div>
                    <!--Card content-->

                </div>
                <!--Card-->

            </div>
            <!--Grid column-->



        </div>
        <!--Grid row-->

    </section>
    <!--Section: Products v.3-->

    <!-- end -->

</div>


<app-footer *ngIf="!loader"></app-footer>